<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            Employee search report {{Filter.Category}}
        </div>
    </div>
    <div class="card-body">
        <div class="mt-1">
            <div class="card">
                <div class="card-body py-2">
                    <div class="row my-1">
                        <div class="col-md-4">
                            <label for="EmployeeCode" class="text-label-dark">Employee Code</label>
                            <input class="form-control" placeholder="Ex. EMP001" id="EmployeeCode" name="EmployeeCode"
                                [(ngModel)]="Filter.EmployeeCode" #EmployeeCode="ngModel" maxlength="100" />
                        </div>
                        <div class="col-md-4">
                            <label for="OldEmployeeCode" class="text-label-dark">Old Employee Code</label>
                            <input class="form-control" placeholder="Ex. EMP001" id="OldEmployeeCode"
                                name="OldEmployeeCode" [(ngModel)]="Filter.EmployeeOldCode" #OldEmployeeCode="ngModel"
                                maxlength="100" />
                        </div>
                        <div class="col-md-4">
                            <label for="EmpName" class="text-label-dark">Employee Name</label>
                            <input class="form-control" placeholder="Ex. John Alexander" id="EmpName" name="EmpName"
                                [(ngModel)]="Filter.EmpName" #EmpName="ngModel" maxlength="100" />
                        </div>
                    </div>
                    <div class="row my-1">
                        <div class="col-md-4">
                            <label for="BranchName" class="text-label-dark">Branch Name</label>
                            <input class="form-control" placeholder="Ex. Mumbai" id="BranchName" name="BranchName"
                                [(ngModel)]="Filter.BranchName" #BranchName="ngModel" maxlength="100" />
                        </div>
                        <!-- <div class="col-md-4">
							<label for="Category" class="text-label-dark mb-2">Employee Type</label>
							<br />
							@for (EmployeeCategory of common.EmployeeCategorys; track EmployeeCategory.EmployeeCategory;
							let i =
							$index) {
							<label class="form-check-label link-dark px-1" ngbButtonLabel>
								<input class="form-check-input" type="radio" [value]=EmployeeCategory.Value
									name='Category' [(ngModel)]="Filter.Category" [ngModelOptions]="{standalone: true}">
								{{EmployeeCategory.EmployeeCategory}}
							</label>
							}
							<label class="form-check-label link-dark px-1" ngbButtonLabel>
								<input class="form-check-input" type="radio" value='' name='Category'
									[(ngModel)]="Filter.Category" [ngModelOptions]="{standalone: true}">
								Both
							</label>
						</div> -->
                        <div class="col-md-8">
                            <label for="CustomSelect" class="text-label-dark">Custom</label>
                            <div class="input-group mb-3">
                                <ng-select name="FilterColumns" [items]="FilterColumns" bindLabel="FilterName"
                                    bindValue="ESS_CustomSearchFilterId" [(ngModel)]="Filter.Ess_CustomSearchFilterId"
                                    placeholder="Select Field" style="width: 13rem;" required>
                                </ng-select>
                                <input class="form-control" placeholder="Ex. John Alexander" id="FilterValue"
                                    name="FilterValue" [(ngModel)]="Filter.FilterValue" #FilterValue="ngModel"
                                    maxlength="100" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button type="button" class="btn btn-primary" (click)="GetData();" [disabled]="isDisabled"><i
                                class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Apply':'Loading...'}}</button>
                        &nbsp;
                        <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                            (click)="exportToExcel()">
                            <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Excel':'Loading...'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-2">
            <!-- <div class="row">
				<div class="row">
					<div class="btn-group" role="group" aria-label="Basic example">
						<button type="button" class="btn btn-outline-primary" (click)="setSelectType(1)"
							style="width:100%" [class.active]="Filter.ListType === 1" [value]="1">
							<i class="bi bi-person-badge"></i> Employee
						</button>
						<button type="button" class="btn btn-outline-primary" (click)="setSelectType(2)"
							[class.active]="Filter.ListType === 2" style="width:100%" [value]="2">
							<i class="bi bi-pencil-square"></i> Draft Employee
						</button>
					</div>
				</div>
			</div> -->

            <div class="row p-2">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <!-- <th [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}">
								Action</th> -->
                            <th style="width: 300px;">Details</th>
                            <th style="width: 150px">Branch</th>
                            <th style="width: 100px">Old Code</th>
                            <th style="width: 100px">Registration Date</th>
                            <th style="width: 100px">Joining Date</th>
                            <th style="width: 100px">Birth Date</th>
                            <th style="width: 100px">Rating</th>
                            <th style="width: 100px">Working Status</th>
                            <th style="width: 100px">Active</th>
                            <!-- <th style="width: 50px">Employee Type</th> -->
                            <th style="width: 200px"
                                [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">Client
                            </th>
                            <th style="width: 200px"
                                [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">Site
                            </th>
                            <th style="width: 100px">AadhaarNo</th>
                            <th style="width: 100px">PANNo</th>
                            <th>Approval Status</th>
                            <th>Approval Pending With</th>
                            <th>Registration Type</th>
                            <!-- <th>Rating</th>
						<th>Progress</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of EmployeeData; let i = index">
                            <!-- <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}"
								class="p-1">
								<div ngbDropdown class="arrow-none text-center">
									<i class="bi bi-three-dots-vertical dropdown-toggle-none" ngbDropdownToggle></i>
									<div ngbDropdownMenu>
										<button ngbDropdownItem type="button"
											*ngIf="this.common.PageRight.IsEdit && (element['ApprovalStatus'] == null || this.common.ToLowerCase(element['ApprovalStatus']) == '' || this.common.ToLowerCase(element['ApprovalStatus']) == 'approved')"
											[routerLink]="['/onboarding/register/add/' + element['EmpMasterId'] + '/' + Filter.IsDraft]"><i
												class="bi bi-pencil-square me-2"></i>Edit</button>
										<button ngbDropdownItem type="button" *ngIf="this.common.PageRight.IsView"
											[routerLink]="['/onboarding/register/detail/' + element['EmpMasterId'] + '/' + Filter.IsDraft]"><i
												class="bi bi-eye  me-2"></i>View</button>
									</div>
								</div>
							</td> -->
                            <td style="width: 300px;">
                                <div class="row" style="align-items: center;" style="align-items: center;width: 300px;">
                                    <div class="col-2">
                                        <img *ngIf="element['Photo'] != null && element['Photo'] != ''"
                                            (click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(element['Photo'])" />
                                        <div *ngIf="element['Photo'] == null || element['Photo'] == ''"
                                            (click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(element['EmployeeName'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-10">
                                        <span class="text-label">{{element['EmployeeName']}}</span><br />
                                        <span class="text-label-light">#{{element['EmpCode']}} <span
                                                *ngIf="element['DesignationName'] != null && element['DesignationName'] != ''">[{{element['DesignationName']}}]</span></span><br />
                                    </div>
                                </div>
                            </td>
                            <td style="width: 150px">
                                <div style="width: 150px">{{element['BranchName']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px">{{element['EmpOldCode']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px">{{element['RegistrationDate']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px">{{element['JoiningDate']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px">{{element['BirthDate']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px">{{element['Rating']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px">{{element['WorkingStatus']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px"><span class="badge"
                                        [ngClass]="{'success': element['Active'],'danger': !element['Active']}">
                                        {{element['Active']?'Active':'Deactive'}}</span></div>
                            </td>
                            <!-- <td style="width: 50px">
								<div style="width: 50px">{{element['EmpType']}}</div>
							</td> -->
                            <td style="width: 200px"
                                [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">
                                <div style="width: 200px">{{element['ClientGroupName']}}</div>
                            </td>
                            <td style="width: 200px"
                                [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">
                                <div style="width: 200px">{{element['SiteName']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px">{{element['AadharNo']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px">{{element['PANNo']}}</div>
                            </td>
                            <td>{{ element['ApprovalStatus'] }}</td>
                            <td>{{element['ApprovalPendingWith']}}</td>
                            <td>{{element['RegistrationType']}}</td>
                            <!-- <td>
							{{element['Rating']}}<i class="bi bi-star-fill ms-1 editIcon"></i>
						</td>
						<td>
							<ngb-progressbar mode="determinate" [value]="60" style="border-radius: 5px;"
								*ngIf="i % 2==0 && i != 5" />
							<ngb-progressbar mode="determinate" class="progressworning" [value]="40"
								style="border-radius: 5px;" *ngIf="i % 2==1 && i != 5" />
							<ngb-progressbar mode="determinate" class="progresssuccess" [value]="100"
								style="border-radius: 5px;" *ngIf="i == 5" />
							<label style="float: inline-end; font-size: 10px; color: #585BD5;">{{i % 2==0 && i
								!=
								5?'60':i == 5?100:40}}%</label>

						</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>